module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar logo            = (helpers.detectRenderedImage(model.logo, model._logo) || {}).rendered || {};\nvar logoInverted    = (helpers.detectRenderedImage(model.invertedLogo, model._invertedLogo) || {}).rendered || {};\n%>\n<div>\n<img class=\"logo\" alt=\"<%= logo.alt %>\" title=\"<%= logo.title %>\" src=\"<%= logo.url %>\">\n<img class=\"logo logoInverted\" alt=\"<%= logoInverted.alt %>\" title=\"<%= logoInverted.title %>\" src=\"<%= logoInverted.url %>\">\n<img class=\"arrow black\" src=\"/images/backArrowBlack.svg\"></img>\n<img class=\"arrow gray\" src=\"/images/backArrowGray.svg\"></img>\n<img class=\"arrow white\" src=\"/images/backArrowWhite.svg\"></img>\n</div>"
  , __filename = "components/templates/headPanel/backButton.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var logo            = (helpers.detectRenderedImage(model.logo, model._logo) || {}).rendered || {};
var logoInverted    = (helpers.detectRenderedImage(model.invertedLogo, model._invertedLogo) || {}).rendered || {};

    ; __line = 4
    ; __append("\n<div>\n<img class=\"logo\" alt=\"")
    ; __line = 6
    ; __append(escapeFn( logo.alt ))
    ; __append("\" title=\"")
    ; __append(escapeFn( logo.title ))
    ; __append("\" src=\"")
    ; __append(escapeFn( logo.url ))
    ; __append("\">\n<img class=\"logo logoInverted\" alt=\"")
    ; __line = 7
    ; __append(escapeFn( logoInverted.alt ))
    ; __append("\" title=\"")
    ; __append(escapeFn( logoInverted.title ))
    ; __append("\" src=\"")
    ; __append(escapeFn( logoInverted.url ))
    ; __append("\">\n<img class=\"arrow black\" src=\"/images/backArrowBlack.svg\"></img>\n<img class=\"arrow gray\" src=\"/images/backArrowGray.svg\"></img>\n<img class=\"arrow white\" src=\"/images/backArrowWhite.svg\"></img>\n</div>")
    ; __line = 11
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/headPanel/backButton.ejs

}